var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 46 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", { attrs: { width: "46", height: "46", fill: "white" } }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9123",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "46",
            height: "46",
          },
        },
        [
          _c("rect", {
            attrs: { width: "46", height: "46", rx: "6", fill: "#C4C4C4" },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9123)" } }, [
        _c("path", {
          attrs: { d: "M47.654 0H-0.126953V47.781H47.654V0Z", fill: "#1C84F1" },
        }),
        _c("path", {
          attrs: {
            d: "M-1.65625 46.5494V0H47.6541V3.91048e-05C47.6541 25.7085 26.8132 46.5494 1.10473 46.5494H-1.65625Z",
            fill: "#24A5FA",
          },
        }),
        _c("path", {
          attrs: {
            d: "M23.1951 1.95524e-05V0H-1.65625V23.4599H-0.264772C12.6917 23.4599 23.1951 12.9565 23.1951 1.95524e-05Z",
            fill: "#1C84F1",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }